// src/config/firebase.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// 這裡填入您原本的 Firebase 設定 (從截圖抄錄過來的)
const firebaseConfig = {
  apiKey: "AIzaSyD-SOaAvr8CkBZvPaXeWCGeto0YZRItM4Y",
  authDomain: "chengkai-math.firebaseapp.com",
  projectId: "chengkai-math",
  storageBucket: "chengkai-math.firebasestorage.app",
  messagingSenderId: "1057900325354",
  appId: "1:1057900325354:web:5a0aff9df3574e1db2aa93",
};

// 初始化邏輯 (單例模式：防止重複初始化報錯)
let firebaseApp;
try {
  if (!getApps().length) {
    firebaseApp = initializeApp(firebaseConfig);
  } else {
    firebaseApp = getApp();
  }
} catch (e) {
  console.error("Firebase Init Error:", e);
}

// 匯出 auth 和 db 供全站使用
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
